import React, { useState } from "react";
import LeftMenu from "../../../components/layout/leftMenu";
import { ToastContainer } from "react-toastify";
import Header from "../../../components/layout/header";
import { useNavigate } from "../../../components/hooks/hooks";
import { FaPerson } from "react-icons/fa6";

export default function Reports() {
  const navigate = useNavigate();
  const [menuClick, setMenuClick] = useState(false);
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };
  return (
    <div className="main-wrapper">
      <div className="top-color"></div>
      <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
      <div className="content-wrapper">
        <Header
          Header="Reports"
          toggleMenu={toggleMenu}
          menuClick={menuClick}
        />
        <div className="main-container">
          <ToastContainer
            enableMultiContainer
            containerId={"D"}
            position="bottom-right"
            autoClose={1500}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          <div className="card main-card">
            <div className="card-body">
              <div className="row">
                <div
                  className="col-xxl-2 col-lg-3 col-md-6 padding-left-right-change"
                  onClick={() =>
                    navigate("/dashboard/reports/analytics-reports")
                  }
                >
                  <div className="card main-card-box dashboard-boxes">
                    <div className="card-body">
                      <div className="box_splite box_split_sm">
                        <div className="right_splite">{<FaPerson />}</div>
                        <div className="left_splite">
                          <h3 className="box-head">Requirement Analytics</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
